module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_3009.f1fbde5d.png";